<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {ExemplarWithDocumentAndDiscardion} from 'src/typings';
    import type {PaginationData} from '../../search-manager/pagination';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {fade} from 'svelte/transition';
    import {exists} from 'shared/utils/custom-utils';
    import Labels from 'shared/components/kp-label/Labels.svelte';
    import KpSearchResultGenericTable from '../KpSearchResultGenericTable.svelte';
    import Label from 'shared/components/kp-label/Label.svelte';

    export let exemplarsPaginationData: PaginationData<ExemplarWithDocumentAndDiscardion>;

    const localize = getLocalization();
</script>

<KpSearchResultGenericTable>
    <tr slot="header">
        <th class="header-access-number">{localize(/* @kp-localization exemplar.AccessNumber.abbr */ 'exemplar.AccessNumber.abbr')}</th>
        <th class="header-signature">{localize(/* @kp-localization exemplar.Signature.abbr */ 'exemplar.Signature.abbr')}</th>
        <th class="header-document-isbn">ISBN</th>
        <th class="header-document-name">{localize(/* @kp-localization commons.nazev */ 'commons.nazev')}</th>
        <th class="header-document-author">{localize(/* @kp-localization commons.autor */ 'commons.autor')}</th>
        <th class="header-department">{localize(/* @kp-localization exemplar.department */ 'exemplar.department')}</th>
        <th class="header-location">{localize(/* @kp-localization exemplar.location */ 'exemplar.location')}</th>
        <th class="header-acquisition-year">{localize(/* @kp-localization exemplar.acquisitionYear */ 'exemplar.acquisitionYear')}</th>
        <th class="header-fond">Fond</th>
        <th class="header-discard-number">{localize(/* @kp-localization exemplar.ubytek */ 'exemplar.ubytek')}</th>
    </tr>

    <svelte:fragment slot="body">
        {#each exemplarsPaginationData.items as exemplar(exemplar.id)}
            <tr in:fade>
                <td class="data-access-number">
                    {#if exists(exemplar.accessNumber)}
                        {exemplar.accessNumber}
                    {/if}
                </td>

                <td class="data-signature">
                    {#if exists(exemplar.signature)}
                        {exemplar.signature}
                    {/if}
                </td>

                <td class="data-document-isbn">
                    <Labels labeleds={exemplar.documentIsbns}/>
                </td>

                <td class="data-document-name">
                    <Label labeled={exemplar.record}/>
                </td>

                <td class="data-document-author">
                    <Labels labeleds={exemplar.documentMainAuthors}/>
                </td>

                <td class="data-department">{pipe(exemplar.department, loc())}</td>

                <td class="data-location">{pipe(exemplar.location, loc())}</td>

                <td class="data-acquisition-year">{exemplar.acquisitionYear}</td>

                <td class="data-fond">{pipe(exemplar.fond, loc())}</td>

                <td class="data-discard-number">
                    {#if exists(exemplar.discardionDiscardNumber)}
                        {exemplar.discardionDiscardNumber}
                    {/if}
                </td>
            </tr>
        {/each}
    </svelte:fragment>
</KpSearchResultGenericTable>

<style lang="less">
    .data-document-name,
    .data-document-author {
        min-width: 225px;
    }

    .data-department {
        min-width: 175px;
    }
</style>